<template>
  <div id="landing">
    <div class="container">
      <img src="../assets/materialflows copy-03.svg" class="" style="max-width:400px; margin-top:30px;">
    </div>

    <div class=" d-flex align-items-center" style="height:calc(100vh - 100px)">
      <div class="container">
        <h1 class="main-title">{{ $t('Welcome to the materialflows quiz') }}</h1>
        <router-link to="/config" class="btn btn-xl btn-primary" style="margin-top:20px;">{{ $t('Start quiz') }}</router-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Landing'
}
</script>



// WEBPACK FOOTER //
// src/components/Landing.vue